import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { z } from 'zod';
import { ClientsTab } from '@/pages/ClientsTab/ClientsTab.tsx';
import { clientsInfiniteQueryOptions } from '@/pages/ClientsTab/api/clients.api.ts';
import { getAccountantExternalId } from '@/contexts/accountantExternalId.ts';

const defaultValues = {
  search: '',
} as const;

const searchSchema = z.object({
  search: z.string().default(defaultValues.search).catch(defaultValues.search),
});

export const Route = createFileRoute('/_index/clients')({
  component: ClientsTab,
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  loader: ({ context }) => {
    const externalId = getAccountantExternalId();
    if (externalId) {
      return context.queryClient.ensureInfiniteQueryData(clientsInfiniteQueryOptions(externalId));
    }
  },
});
